<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import './reset.css';
import { isMobile } from '@/utils/ua';

export default {
  name: 'App',
  mounted() {
    isMobile();
  },
};

</script>

<style>
#app {
  height: 100%;
}
body {
  background: #f9f9f9;
}
.main-wrapper {
  min-height: 5.25rem;
}
@media screen and (max-width: 850px){ 
  .main-wrapper {
    width: 100% !important;
    min-height: 9rem;
  }
}
</style>
